// extracted by mini-css-extract-plugin
module.exports = {"mask":"Popup_mask__1-WpP","popup":"Popup_popup__weO_V","inner":"Popup_inner__3mTPf","close":"Popup_close__FXjmf"};